export function InformationIcon() {
  return (
    <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M29 0.666626C13.36 0.666626 0.666626 13.36 0.666626 29C0.666626 44.64 13.36 57.3333 29 57.3333C44.64 57.3333 57.3333 44.64 57.3333 29C57.3333 13.36 44.64 0.666626 29 0.666626ZM31.8333 43.1666H26.1666V26.1666H31.8333V43.1666ZM31.8333 20.5H26.1666V14.8333H31.8333V20.5Z"
        fill="black" />
    </svg>

  );
}